import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "chip-set";
var attributes = {
    VERTICAL: 'vertical',
    TYPE: 'type',
    DENSE: 'dense',
    DISABLED: 'disabled'
};
var classes = {
    ROOT: 'tyl-chip-set',
    VERTICAL: 'tyl-chip-set--vertical'
};
var selectors = {
    ROOT: "." + classes.ROOT
};
export var CHIP_SET_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    selectors: selectors
};
